import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors, sliceKeys } from '../../model';
import { useRoomsQuery, roomsSelectors } from '../../api/rooms';
import { getBaseOptions } from './helpers';

const { selectHouses } = selectors[sliceKeys.houses];

const dataTypes = {
  original: 'original',
  groupByHouses: 'groupByHouses',
};

const _options = {
  [dataTypes.original]: {},
  [dataTypes.groupByHouses]: { select: roomsSelectors.groupByHouses },
};

const delay = 800;

export const useDebouncedRoomsData = ({ options, dataType } = {}) => {
  const houses = useSelector(selectHouses);

  const [ids, setIds] = useState([]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIds(houses.map((item) => item.id));
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [houses]);

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  const params = useMemo(() => ({ houseId: ids }), [ids]);

  return useRoomsQuery({
    params,
    options: { ...baseOptions, ...options },
  });
};

useDebouncedRoomsData.dataTypes = dataTypes;
